import React from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetAllKybVerificationsQuery } from '../../../reactWrapper/Redux/apiSlice';

import Table from '../Table';
import Pagination from '../../Pagination/Pagination';
import Status from '../../Status/Status';

const getInitials = (name) => {
  if (!name) return "?"
  return name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("")
}

const AllKybTable = () => {

  const siblingCount = 1;
  const pageColumn = 1;
  const [pageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const { data } = useGetAllKybVerificationsQuery(page)

  const handlePageChange = useCallback(
    (page) => {
      setPage(page - 1);
    },
    [page]
  );

  const tableHeader = useMemo(
    () => [
      {
        title: 'Company',
        key: 'company',
      },
      {
        title: 'Industry',
        key: 'industry',
      },
      {
        title: 'Status',
        key: 'status',
      },
      {
        title: 'Documents',
        key: 'documents',
      },
      {
        title: 'Date',
        key: 'date',
      },
      {
        title: '',
        key: 'details',
      },
    ],
    []
  );

  const countApprovedDocs = (kyb) => {
    const statuses = [
      kyb?.identification_file_status,
    ]
    return statuses.filter((s) => s === 'approved').length
  }

  const modifiedKybList = useMemo(() => {
    return data?.data?.map((each) => [
      <div className='flex gap-[18px] items-center'>
        <div className='w-11 h-11'>
          {each?.company?.logo ? (
            <img
              src={each.company.logo}
              alt={each.company.name ?? ""}
              className='w-full h-full rounded-full object-cover'
            />
          ) : (
            <div className='w-full h-full rounded-full bg-brand-navy flex items-center justify-center text-white text-sm font-semibold'>
              {getInitials(each?.company?.name || each?.legal_name)}
            </div>
          )}
        </div>
        <div>
          <p className='font-semibold text-brand-navy'>{each?.company?.name ?? each?.legal_name ?? "N/A"}</p>
          <p className='text-xs text-muted-foreground'>{each?.user?.email ?? ""}</p>
        </div>
      </div>,
      <span className="capitalize">{each?.category ?? "N/A"}</span>,
      <Status label={each?.status?.replace('-', ' ') ?? "N/A"} />,
      <span className="text-sm tabular-nums">
        {countApprovedDocs(each)} / 1 approved
      </span>,
      new Date(each?.created_at).toLocaleDateString(),
      <Link
        className='text-sm inline-block rounded-lg border border-border py-[1.56px] px-[11.7px] text-muted-foreground'
        to={`/client/kyb/${each?.id}`}
      >
        Details
      </Link>
    ])
  }, [data]);

  useEffect(() => {
    setTotalCount(data?.total ?? 0);
  }, [data]);

  return (
    <div className='w-full space-y-4'>
      <Table
        header={tableHeader}
        label='KYB Verification Requests'
        column={modifiedKybList}
      />

      <section className="w-full">
        <Pagination
          rangeStart={
            totalCount !== 0
              ? (page || 0) * ((pageSize || 0) * pageColumn) + 1
              : 0
          }
          totalCount={totalCount}
          currentPage={(page || 0) + 1}
          pageSize={pageSize}
          pageColumn={pageColumn}
          siblingCount={siblingCount}
          onPageChange={handlePageChange}
          className="pt-9"
        />
      </section>
    </div>
  );
};

export default AllKybTable
